import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
    selector: 'app-create-button',
    templateUrl: './create-button.component.html',
    standalone: false
})
export class CreateButtonComponent extends AppBaseComponent {
  @Input() label: string;
  @Input() tooltip: string;
  @Output() triggered = new EventEmitter<void>();
  
  onClick(): void {
    this.triggered.emit();
  }
}
